<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:12
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-04 11:24:02
-->
<template>
  <van-tabbar
    v-model="activeName"
    :border="footerBorder"
    :z-index="zIndex"
    inactive-color="#b6b6b6"
  >
    <!-- 跳转到个体户首页 -->
    <van-tabbar-item replace name="home" to="/individual_index">
      <span class="footer-text">首页</span>
      <template #icon="{active}">
        <img :src="active ? home.active : home.normal" class="footer-img" />
      </template>
    </van-tabbar-item>

    <!-- 跳转到个体户列表 -->
    <van-tabbar-item replace name="tasksList" to="/individual_list">
      <span class="footer-text">我的个体户</span>
      <template #icon="{active}">
        <img :src="active ? tasksList.active : tasksList.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace name="salary" to="/salary">
      <span class="footer-text">我的收入</span>
      <template #icon="{active}">
        <img :src="active ? salary.active : salary.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item replace name="user" to="/user">
      <span class="footer-text">我的</span>
      <template #icon="{active}">
        <img :src="active ? user.active : user.normal" class="footer-img" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  name: "job-footer",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  watch: {
    $route: function (to, from) {
      this.activeName = to.meta.showFooter;
    },
  },
  data() {
    return {
      footerBorder: false,
      zIndex: 99,
      activeName: this.$route.meta.showFooter,
      home: {
        normal: require("./assets/icon_home.png"),
        active: require("./assets/icon_home_active.png"),
      },
      tasksList: {
        normal: require("./assets/icon_task.png"),
        active: require("./assets/icon_task_active.png"),
      },
      salary: {
        normal: require("./assets/icon_salary.png"),
        active: require("./assets/icon_salary_active.png"),
      },
      user: {
        normal: require("./assets/icon_user.png"),
        active: require("./assets/icon_user_active.png"),
      },
    };
  },
};
</script>